<template>
  <div class="date-range-selector">
    <el-select
      v-model="dateRangeType"
      style="width: 70px"
      @change="
        (v) => {
          if (datePickerOptionStart && datePickerOptionEnd) {
            quickDateRange = '';
          }
          switch (v) {
            case 1:
              handleQuickDateRangeSearch('this-week');
              break;
            case 2:
              handleQuickDateRangeSearch('this-month');
              break;
            case 3:
              handleQuickDateRangeSearch('this-year');
              break;
          }
        }
      "
    >
      <el-option :value="1" label="周"></el-option>
      <el-option :value="2" label="月"></el-option>
      <el-option :value="3" label="年"></el-option>
    </el-select>
    <!-- 按周 -->
    <div class="range-wrap" v-if="dateRangeType === 1">
      <el-date-picker
        v-model="dateRangeValueStart"
        type="week"
        format="yyyy 第 WW 周"
        placeholder="开始时间"
        value-format="yyyy-MM-dd"
        @change="handleDateRangeChange('week', 'start')"
        :picker-options="datePickerOptionStart"
      >
      </el-date-picker>
      <span class="divide">至</span>
      <el-date-picker
        v-model="dateRangeValueEnd"
        type="week"
        format="yyyy 第 WW 周"
        placeholder="结束时间"
        value-format="yyyy-MM-dd"
        @change="handleDateRangeChange('week', 'end')"
        :picker-options="datePickerOptionEnd"
      >
      </el-date-picker>
    </div>
    <!-- 按月 -->
    <div class="range-wrap" v-if="dateRangeType === 2">
      <el-date-picker
        v-model="dateRangeValueStart"
        type="month"
        placeholder="开始时间"
        @change="handleDateRangeChange('month')"
        value-format="yyyy-MM-dd"
        :picker-options="datePickerOptionStart"
      >
      </el-date-picker>
      <span class="divide">至</span>
      <el-date-picker
        v-model="dateRangeValueEnd"
        type="month"
        placeholder="结束时间"
        @change="handleDateRangeChange('month')"
        value-format="yyyy-MM-dd"
        :picker-options="datePickerOptionEnd"
      >
      </el-date-picker>
    </div>
    <!-- 按年 -->
    <div class="range-wrap" v-if="dateRangeType === 3">
      <el-date-picker
        v-model="dateRangeValueStart"
        type="year"
        placeholder="开始时间"
        @change="handleDateRangeChange('year')"
        value-format="yyyy-MM-dd"
        :picker-options="datePickerOptionStart"
      >
      </el-date-picker>
      <span class="divide">至</span>
      <el-date-picker
        v-model="dateRangeValueEnd"
        type="year"
        placeholder="结束时间"
        @change="handleDateRangeChange('year')"
        value-format="yyyy-MM-dd"
        :picker-options="datePickerOptionEnd"
      >
      </el-date-picker>
    </div>
    <div class="buttons-wrap">
      <div
        class="mwow-button"
        :class="{ success: quickDateRange === 'last-week' }"
        @click="handleQuickDateRangeSearch('last-week')"
      >
        上周
      </div>
      <div
        class="mwow-button"
        :class="{ success: quickDateRange === 'this-week' }"
        @click="handleQuickDateRangeSearch('this-week')"
      >
        本周
      </div>
      <div
        class="mwow-button"
        :class="{ success: quickDateRange === 'last-month' }"
        @click="handleQuickDateRangeSearch('last-month')"
      >
        上月
      </div>
      <div
        class="mwow-button"
        :class="{ success: quickDateRange === 'this-month' }"
        @click="handleQuickDateRangeSearch('this-month')"
      >
        本月
      </div>
      <div
        class="mwow-button"
        :class="{ success: quickDateRange === 'last-year' }"
        @click="handleQuickDateRangeSearch('last-year')"
      >
        上年
      </div>
      <div
        class="mwow-button"
        :class="{ success: quickDateRange === 'this-year' }"
        @click="handleQuickDateRangeSearch('this-year')"
      >
        本年
      </div>
    </div>
  </div>
</template>
<script>
import {
  dateFormat,
  getCurrentMonth,
  getCurrentWeek,
} from "@/utils/timeFormat";
export default {
  props: ["origin-data"],
  watch: {
    originData(n) {
      // 父组件值传入
      if (n.quick) {
        this.handleQuickDateRangeSearch(n.quick);
      } else {
        if (n.range && n.range.length === 2) {
          this.dateRangeValueStart = n.range[0];
          this.dateRangeValueEnd = n.range[1];
          if (n.rangeType === "week") {
            this.dateRangeType = 1;
          }
          if (n.rangeType === "month") {
            this.dateRangeType = 2;
          }
          if (n.rangeType === "year") {
            this.dateRangeType = 3;
          }
          this.handleDateRangeChange(n.rangeType || "week", "");
        }
      }
    },
  },
  data() {
    return {
      dateRangeType: 1, // 周月年
      dateRangeValueStart: "", // 开始时间
      dateRangeValueEnd: "", // 结束时间
      quickDateRange: "", // 快速时间选择
      datePickerOptionStart: {
        disabledDate: (now) => {
          if (!this.dateRangeValueStart && this.dateRangeValueEnd) {
            return (
              now.getTime() - 5 * 24 * 60 * 60 * 1000 >
              new Date(this.dateRangeValueEnd).getTime()
            );
          } else {
            return false;
          }
        },
        firstDayOfWeek: 1,
      },
      datePickerOptionEnd: {
        disabledDate: (now) => {
          if (this.dateRangeValueStart && !this.dateRangeValueEnd) {
            return (
              now.getTime() + 2 * 24 * 60 * 60 * 1000 <
              new Date(this.dateRangeValueStart).getTime()
            );
          } else {
            return false;
          }
        },
        firstDayOfWeek: 1,
      },
    };
  },
  mounted() {
    this.handleQuickDateRangeSearch("this-week");
  },
  methods: {
    handleEmit() {
      if (this.dateRangeValueStart && this.dateRangeValueEnd) {
        if (
          new Date(this.dateRangeValueStart).getTime() >
          new Date(this.dateRangeValueEnd).getTime()
        ) {
          this.$message({
            type: "warning",
            message: "结束时间不可早于开始时间",
          });
          return false;
        }
        this.$emit("change", {
          type: this.dateRangeType,
          dates: [this.dateRangeValueStart, this.dateRangeValueEnd],
        });
      }
    },
    handleQuickDateRangeSearch(type) {
      let now = new Date();
      let start = "";
      let end = "";
      this.quickDateRange = type;
      switch (type) {
        case "this-week":
          const cw = getCurrentWeek(now);
          start = dateFormat("YYYY-mm-dd", cw[0]);
          end = dateFormat("YYYY-mm-dd", now);
          this.dateRangeType = 1;
          break;
        case "last-week":
          const pw = getCurrentWeek(now.getTime() - 7 * 24 * 60 * 60 * 1000);
          start = dateFormat("YYYY-mm-dd", pw[0]);
          end = dateFormat("YYYY-mm-dd", pw[1]);
          this.dateRangeType = 1;
          break;
        case "this-month":
          const cm = getCurrentMonth(now);
          start = dateFormat("YYYY-mm-dd", cm[0]);
          end = dateFormat("YYYY-mm-dd", now);
          this.dateRangeType = 2;
          break;
        case "last-month":
          const d = now.getDate();
          const pm = getCurrentMonth(now.getTime() - d * 24 * 60 * 60 * 1000);
          start = dateFormat("YYYY-mm-dd", pm[0]);
          end = dateFormat("YYYY-mm-dd", pm[1]);
          this.dateRangeType = 2;
          break;
        case "this-year":
          start = `${now.getFullYear()}-01-01`;
          end = dateFormat("YYYY-mm-dd", now);
          this.dateRangeType = 3;
          break;
        case "last-year":
          start = `${now.getFullYear() - 1}-01-01`;
          end = `${now.getFullYear() - 1}-12-31`;
          this.dateRangeType = 3;
          break;
      }
      this.dateRangeValueStart = start;
      this.dateRangeValueEnd = end;
      this.handleEmit();
    },
    handleDateRangeChange(type, pos) {
      if (!this.dateRangeValueStart || !this.dateRangeValueEnd) {
        return false;
      }
      let s = new Date(this.dateRangeValueStart);
      let e = new Date(this.dateRangeValueEnd);
      if (type === "week") {
        if (pos === "start") {
          this.dateRangeValueStart = dateFormat(
            "YYYY-mm-dd",
            s.getTime() - 24 * 60 * 60 * 1000
          );
        } else if (pos === "end") {
          this.dateRangeValueEnd = dateFormat(
            "YYYY-mm-dd",
            e.getTime() + 5 * 24 * 60 * 60 * 1000
          );
        } else {
          // 兼容周模式下父组件传值
          this.dateRangeValueStart = dateFormat(
            "YYYY-mm-dd",
            s.getTime() - 24 * 60 * 60 * 1000
          );
          this.dateRangeValueEnd = dateFormat(
            "YYYY-mm-dd",
            e.getTime() + 5 * 24 * 60 * 60 * 1000
          );
        }
      }
      if (type === "month") {
        this.dateRangeValueEnd = dateFormat(
          "YYYY-mm-dd",
          getCurrentMonth(this.dateRangeValueEnd)[1]
        );
      }
      if (type === "year") {
        this.dateRangeValueEnd = dateFormat(
          "YYYY-mm-dd",
          `${e.getFullYear()}-12-31`
        );
      }
      this.quickDateRange = "";
      this.handleEmit();
    },
  },
};
</script>
<style lang="scss" scoped>
.date-range-selector {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  .range-wrap {
    margin: 0 12px;
    .divide {
      margin: 0 12px;
      font-size: 14px;
      color: #5c5d5e;
    }
  }
  .buttons-wrap {
    display: flex;
    .mwow-button {
      margin-right: 8px;
      white-space: nowrap;
    }
  }
}
</style>
